import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { Security } from '@ddt-web/domain';
import { NumberUtil } from '@ddt-web/generic-utils';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'securities-table',
	templateUrl: './securities-table.component.html',
	styleUrls: ['./securities-table.component.scss']
})
export class SecuritiesTableComponent implements OnChanges {
	@Input() public columns: Array<any>;
	@Input() public data: Array<Security>;
	@Input() public sortable: boolean;
	@Input() public filter: string;
	@Input() public renderPSView: boolean;
	@ViewChild('table') public table: ElementRef;

	public viewData: Array<Array<any>> = [];
	public isAscending: boolean;
	public sortedColumn: number = -1;
	private datePipe: DatePipe = new DatePipe('en-US');

	constructor(private contentService: ContentService) { }

	public ngOnChanges(changes: SimpleChanges): void {
		if (typeof this.filter !== 'undefined') {
			Array.from(this.table.nativeElement.querySelectorAll('tbody tr')).forEach((row: any) => {
				row.hidden = false;
				if (row.innerText.toLowerCase().indexOf(this.filter.toLowerCase()) === -1) {
					row.hidden = true;
				}
			});
		}

		if (this.data && this.columns) {
			this.viewData = this.transform(this.data);
		}
		this.sortedColumn = -1;
	}

	public getContent(key: string): string {
		return this.contentService.get(key, key);
	}

	private transform(data: Array<Security>): Array<Array<any>> {
		return data.map(sec =>
			this.columns.map(col => {
				let value: any = sec[col.name];

				// value is formattable - apply formatting
				if (value && col.formattable) {
					if (col.formatType === 'date') {
						value = this.datePipe.transform(value, 'shortDate', 'UTC');
					}
					if (col.formatType === 'number') {
						value = NumberUtil.formatWithPrecisionRounding(value, 2);
					}
				}

				return value;
			})
		);
	}

	private comparator(column: any): (a: any, b: any) => number {
		return (a, b) => {
			const l: any = this.isAscending ? a[column.name] : b[column.name];
			const r: any = this.isAscending ? b[column.name] : a[column.name];

			return column.formattable ? this.compareFormattable(column.formatType, l, r) : this.compareStrings(l, r);
		};
	}

	private compareStrings(l: any, r: any): number {
		return l.toString().localeCompare(r.toString());
	}
	private compareFormattable(formatType: string, lVal: any, rVal: any): number {
		if (formatType === 'date') {
			// Handle time strings, epoch numbers & date objects
			lVal = new Date(lVal).getTime();
			rVal = new Date(rVal).getTime();
		}
		// Treat as numbers
		lVal = parseFloat(lVal);
		rVal = parseFloat(rVal);

		lVal = isNaN(lVal) ? Number.NEGATIVE_INFINITY : lVal;
		rVal = isNaN(rVal) ? Number.NEGATIVE_INFINITY : rVal;
		return lVal - rVal;
	}

	public sort(event: Event, index: number): void {
		if (this.sortable) {
			const column: any = this.columns[index];
			this.isAscending = !this.isAscending;
			this.data.sort(this.comparator(column));
			const sortedData = this.data;
			this.viewData = this.transform(sortedData);
		}
	}
}
